import * as React from "react"
import type { SVGProps } from "react"
const SvgMagicWand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m5.99 6.55-.7 1.62a.44.44 0 0 1-.81 0l-.71-1.62-1.63-.71a.44.44 0 0 1 0-.8l1.63-.71.7-1.63a.44.44 0 0 1 .81 0l.7 1.63 1.63.7a.44.44 0 0 1 0 .8zm9.72 1.67.6-1.36 1.35-.59a.37.37 0 0 0 0-.67l-1.36-.59-.59-1.35a.37.37 0 0 0-.67 0L14.45 5l-1.35.59a.37.37 0 0 0 0 .67l1.35.6.6 1.35a.37.37 0 0 0 .66 0m-11.1 6.96-.46 1.08a.3.3 0 0 1-.54 0l-.47-1.08-1.09-.48a.3.3 0 0 1 0-.53l1.09-.47.47-1.09a.3.3 0 0 1 .54 0l.47 1.09 1.08.47a.3.3 0 0 1 0 .53z" />
    <path
      fillRule="evenodd"
      d="M8.88 8.02a2 2 0 0 1 2.83 0l9.58 9.59a2 2 0 0 1 0 2.83l-1.41 1.4a2 2 0 0 1-2.83 0l-9.59-9.57a2 2 0 0 1 0-2.83zm1.41 1.42 1.42 1.41-1.42 1.42-1.41-1.42zm8.17 11-6.75-6.76 1.41-1.41 6.76 6.75z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgMagicWand
